import type { BeckyModel } from '@wix/thunderbolt-becky-root'
import type { Data, FetchFn, MetricsReporter, RefSchemas } from '@wix/thunderbolt-becky-types'
import { singleTransaction } from '@wix/thunderbolt-catharsis'
import { shapeIdsNode as shapeIds } from './shapeIdsNode'
import { cursorShapeIdsNode as cursorShapeIds } from './cursorShapeIdsNode'
import { BuildSvgUrl, fetchShapes } from './fetchShapes'
import { getInvalidationHandler } from './invalidationHandler'
import { createMaterializer, createSimpleMaterializer } from '@wix/materializer'

const RELEVANT_DATA_MAPS: Array<keyof Data> = [
	'document_data',
	'design_data',
	'component_properties',
	'theme_data',
	'cursor',
]

export const findShapes = (
	beckyModel: BeckyModel,
	schemas: RefSchemas,
	runAndReport: <T>(fn: () => T, name: string) => T
): Array<string> => {
	const set = new Set<string>()
	const onInvalidation = getInvalidationHandler(set)

	const isSimpleMaterializer = !!beckyModel.experiments['specs.thunderbolt.simpleMaterializer']

	const catharsisArgs = {
		onInvalidation,
		extensions: { componentNodes: { shapeIds, cursorShapeIds }, schemas },
		materializerFactory: isSimpleMaterializer ? createSimpleMaterializer : createMaterializer,
	}

	singleTransaction(beckyModel, catharsisArgs, RELEVANT_DATA_MAPS, runAndReport)

	return [...set]
}

export const fetchComponentShapes = (
	beckyModel: BeckyModel,
	fetchFn: FetchFn,
	mediaRootUrl: string,
	buildSvgUrl: BuildSvgUrl,
	metricsReporter: MetricsReporter,
	schemas: RefSchemas
): Promise<Record<string, string>> => {
	const shapes = metricsReporter.runAndReport(
		() => findShapes(beckyModel, schemas, metricsReporter.runAndReport),
		'tb-css-find-shapes'
	)
	return fetchShapes(shapes, fetchFn, mediaRootUrl, buildSvgUrl, metricsReporter)
}
